import { IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

/** Copies the full account hash; never opens the row it sits in. */
export default function CopyHashButton({ hash }: { readonly hash: string }) {
  return (
    <Tooltip title="Copy the full hash">
      <IconButton
        size="small"
        aria-label="Copy the full hash"
        onClick={(event) => {
          event.stopPropagation();
          void navigator.clipboard?.writeText(hash);
        }}
      >
        <ContentCopyIcon sx={{ fontSize: 14 }} />
      </IconButton>
    </Tooltip>
  );
}
